import { createSlice } from '@reduxjs/toolkit';

import { REQUEST } from '../../constants/request';

import { fetchMeUserExtraReducers } from './asyncThunk/fetchMeUser';
import { fetchMeUserDataExtraReducers } from './asyncThunk/fetchMeUserData';
import { fetchRebuzzChannelsExtraReducers } from './asyncThunk/fetchRebuzzChannels';
import { fetchThreadChannelsExtraReducers } from './asyncThunk/fetchThreadChannels';

export { fetchMeUser } from './asyncThunk/fetchMeUser';
export { fetchMeUserData } from './asyncThunk/fetchMeUserData';
export { fetchRebuzzChannels } from './asyncThunk/fetchRebuzzChannels';
export { fetchThreadChannels } from './asyncThunk/fetchThreadChannels';

const INITIAL_USER_STATE = {
  user: {
    name: '',
    email: '',
    providers: [],
    id: null,
    properties: {},
    pins: {},
    background: '',
    metadata: {
      createdAt: '',
    },
    wallet: {
      coins: 0,
      currency: 0,
    },
    active: true,
  },
  userRoleMapping: {
    mapping: [],
    roles: [],
  },
  channels: {},
  streams: {},
  organizations: {},
  channelsByRoles: {},
  streamsByRoles: {},
  orgsByRoles: {},
  loading: REQUEST.idle,
  currentRequestId: undefined,
  error: null,
  currentRequestIds: {},
  currentLoadings: {},
  currentErrors: {},
  rebuzzChannels: [],
  threadChannels: [],
};

const currentUserStorage = () =>
  JSON.parse(localStorage.getItem('redux_current_user')) || null;

export const ProfileSlice = createSlice({
  name: 'currentUser',
  initialState: currentUserStorage() || INITIAL_USER_STATE,
  reducers: {
    updateCoins: (state, action) => {
      state.user.wallet.coins = action.payload;
    },
    updateCurrency: (state, action) => {
      state.user.wallet.currency = action.payload;
    },
    setInitialCurrentUserSlice: () => INITIAL_USER_STATE,
    changePersonalDataName: (state, { payload }) => {
      state.user.name = payload.name;
    },
    changePersonalDataEmail: (state, { payload }) => {
      state.user.email = payload.email;
    },
  },
  extraReducers: {
    ...fetchMeUserExtraReducers,
    ...fetchMeUserDataExtraReducers,
    ...fetchRebuzzChannelsExtraReducers,
    ...fetchThreadChannelsExtraReducers,
  },
});

export const {
  updateCoins,
  updateCurrency,
  setInitialCurrentUserSlice,
  changePersonalDataName,
  changePersonalDataEmail,
} = ProfileSlice.actions;

export default ProfileSlice.reducer;

export const selectorCurrentUser = state => state.currentUser.user;
export const selectorCurrentUserId = state => state.currentUser.user.id;
export const selectorCurrentUserName = state => state.currentUser.user.name;
export const selectorCurrentUserProfilePicUrl = state =>
  state.currentUser.user.metadata.profilePicUrl;
export const selectorCurrentUserOrganizations = state =>
  state.currentUser.organizations;
export const selectorCurrentUserStreams = state => state.currentUser.streams;
export const selectorCurrentUserChannels = state => state.currentUser.channels;
export const selectorCurrentUserThreadChannels = state =>
  state.currentUser.threadChannels;
export const selectorCurrentUserChannelsByRoles = state =>
  state.currentUser.channelsByRoles || {};
export const selectorGetUserRebuzzChannels = state =>
  state.currentUser.rebuzzChannels;
export const selectorCurrentUserRebuzzChannelsByType = type => state =>
  state.currentUser.rebuzzChannels?.filter(channel => channel?.type === type) ||
  [];
export const selectorGetGlobalUserRoleMapping = state =>
  state.currentUser.userRoleMapping;
export const selectorGetCurrentUserLoadingStatus = (state, key) =>
  state.currentUser.currentLoadings?.[key] || REQUEST.idle;
export const selectorGetUserWallet = state => state.currentUser.user.wallet;
